module.exports = __webpack_public_path__ + "img/calculator-fill.fa186dc6.svg";